import { Select, Input } from "antd";
import React, { createRef } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import AddButton from "../../../../Componets/Buttons/add";
import { select_search } from "../../../../Controllers/Global";
import { get_product } from "../../../../Controllers/Products/Products";
import Error from "../../../../Componets/Error";
import Modalcomponent from "../../../../Componets/Modal";
import { useState } from "react";

const MRTable = React.forwardRef((props, focus) => {
    const { details, setDetails } = props;

    const [open, setOpen] = useState(false);
    const [modalData, setModalData] = useState();
    const [selectedModalData, setSelectedModalData] = useState();

    const handleSearch = async (e, index) => {
        let data = [...details];

        const select = {
            api: "get-all-products",
            search: e,
            status: 1,
        };

        const search = await select_search(select);

        if (search?.status) {
            let options = [];
            search?.data?.data?.map((value) => {
                options.push({ value: value?._id, label: value?.name });
            });
            data[index].options = options;
            setDetails(data);
        } else {
            toast?.error(search?.message);
        }
    };

    const handleModal = (modaldata) => {
        let data = [...details];
        let product = selectedModalData;
        let index = selectedModalData?.index;

        let product_description = null;
        let product_name = "";
        let product_unit = "";
        let product_unit_name = "";
        let product_conversion = 0;
        let product_unit_details = [];

        let description_ids = [];
        data?.map((v) => { description_ids.push(v?.unit); });

        if (!description_ids?.includes(modaldata)) {
            if (product?.data?._id == modaldata) {
                product_description = product?.data?._id;
                product_name = product?.data?.name;
                product_unit = modaldata;
                product_unit_name = product?.data?.unit?.name;

                if (product?.data?.product_units_details?.length > 0) {
                    product?.data?.product_units_details?.map((value) => {
                        product_unit_details.push({
                            ...value,
                            name: value?.name?.name,
                            unit_quantity: 0,
                        });
                    });
                }
            } else {
                let selected_unit = "";
                let unit_ids = [];

                if (product?.data?.product_units_details?.length > 0) {
                    product?.data?.product_units_details?.map((value) => {
                        unit_ids.push(value?._id);
                    });
                }

                if (unit_ids?.includes(modaldata)) {
                    selected_unit =
                        product?.data?.product_units_details?.[unit_ids.indexOf(modaldata)];
                }

                product_description = product?.data?._id;
                product_name = product?.data?.name;
                product_unit = modaldata;
                product_unit_name = selected_unit?.name?.name;
                product_conversion = selected_unit?.conversion;
            }

            data[index].description = product_description;
            data[index].name = product_name;
            data[index].unit = product_unit;
            data[index].unit_name = product_unit_name;
            data[index].quantity_requested = "";
            data[index].conversion = product_conversion;
            data[index].unit_details_options = product_unit_details;

            setDetails(data);
            setModalData();
            setSelectedModalData();
            focus.current[`quantity_requested${index}`].current.focus();
        } else {
            let selected_index = description_ids?.indexOf(modaldata);
            setDetails(data);
            setModalData();
            setSelectedModalData();
            setTimeout(() => {
                focus.current[`quantity_requested${selected_index}`].current.focus();
            }, 300);
        }
    };

    const handleDescription = async (e, index) => {
        let data = [...details];

        if (e) {
            let params = { id: e };
            const product = await get_product(params);

            if (product?.data?.product_units_details?.length > 0) {
                setOpen(true);
                setModalData([
                    { ...product?.data?.unit, _id: product?.data?._id },
                    ...product?.data?.product_units_details,
                ]);
                setSelectedModalData({ ...product, index: index });
            } else {
                let description_ids = [];
                data?.map((v) => { description_ids.push(v?.description); });

                if (!description_ids?.includes(e)) {
                    data[index].description = product?.data?._id;
                    data[index].name = product?.data?.name;
                    data[index].unit = product?.data?._id;
                    data[index].unit_name = product?.data?.unit?.name;
                    data[index].quantity_requested = "";
                    data[index].unit_details_options = [];
                    setDetails(data);

                    setTimeout(() => {
                        focus.current[`quantity_requested${index}`].current.focus();
                    }, 300);
                } else {
                    let selected_index = description_ids?.indexOf(e);
                    setDetails(data);
                    setTimeout(() => {
                        focus.current[`quantity_requested${selected_index}`].current.focus();
                    }, 300);
                }
            }
        } else {
            // Clear row
            data[index].description = null;
            data[index].name = "";
            data[index].unit = "";
            data[index].unit_name = "";
            data[index].unit_details_options = null;
            data[index].quantity_requested = "";
            data[index].conversion = 0;
            setDetails(data);
        }
    };

    const handleQuantity = (e, index) => {
        let value = e?.target?.value;
        if (value >= 0) {
            let data = [...details];

            let unit_details_options = [];
            if (data?.[index]?.unit_details_options?.length > 0) {
                data?.[index]?.unit_details_options?.map((v) => {
                    unit_details_options.push({
                        ...v,
                        unit_quantity: parseFloat(v?.conversion || 0) * parseFloat(value || 0),
                    });
                });
            }

            data[index].quantity_requested = value;
            data[index].unit_details_options = unit_details_options;
            setDetails(data);
        }
    };

    const handleRemove = (index) => {
        let data = [...details];
        data.splice(index, 1);
        setDetails(data);
    };

    const handleAdd = () => {
        setDetails((prev) => [
            ...prev,
            {
                id: "",
                description: null,
                name: "",
                unit: "",
                unit_name: "",
                unit_details_options: null,
                conversion: 0,
                quantity_requested: "",
                options: [],
            },
        ]);

        setTimeout(() => {
            focus.current[`description${details?.length}`].current.focus();
        }, 100);
    };

    return (
        <div>
            <Modalcomponent
                open={open}
                setOpen={setOpen}
                modalData={modalData}
                setModalData={setModalData}
                selectedModalData={selectedModalData}
                setSelectedModalData={setSelectedModalData}
                handleModal={handleModal}
            />
            <table className="w-full">
                <thead>
                    <tr>
                        <td className="border p-4 text-black">S.NO</td>
                        <td className="border p-4 text-black">DESCRIPTION</td>
                        <td className="border p-4 text-black">UNIT</td>
                        <td className="border p-4 text-black">QTY REQUESTED</td>
                        <td className="border p-4 text-black">DELETE</td>
                    </tr>
                </thead>
                <tbody>
                    {details?.map((value, index) => {
                        focus.current[`description${index}`] = createRef();
                        focus.current[`quantity_requested${index}`] = createRef();

                        return (
                            <React.Fragment key={index}>
                                <tr>
                                    <td className="border p-4 text-center text-gray-700">
                                        {index + 1}
                                    </td>
                                    <td className="border p-4">
                                        {value?.description ? (
                                            <div>{value?.name}</div>
                                        ) : (
                                            <Select
                                                className="w-full text-regular"
                                                name="description"
                                                ref={focus.current[`description${index}`]}
                                                placeholder="Description"
                                                allowClear={true}
                                                showSearch={true}
                                                filterOption={false}
                                                value={value?.description}
                                                options={value?.options}
                                                onSearch={(e) => handleSearch(e, index)}
                                                onClick={() => handleSearch("", index)}
                                                onFocus={() => handleSearch("", index)}
                                                onChange={(e) => handleDescription(e, index)}
                                                autoComplete="off"
                                            />
                                        )}
                                        <Error id={`description${index}`} />
                                    </td>
                                    <td className="border p-4 text-center">
                                        <div>{value?.unit_name}</div>
                                    </td>
                                    <td className="border p-4 text-center">
                                        <Input
                                            type="number"
                                            className="w-full text-regular"
                                            name="quantity_requested"
                                            ref={focus.current[`quantity_requested${index}`]}
                                            placeholder="Quantity"
                                            value={value?.quantity_requested}
                                            onChange={(e) => handleQuantity(e, index)}
                                            autoComplete="off"
                                        />
                                        <Error id={`quantity_requested${index}`} />
                                    </td>
                                    <td className="border p-4 text-center">
                                        <button
                                            type="button"
                                            className="text-lg text-red-500 cursor-pointer hover:text-red-800"
                                            onClick={() => handleRemove(index)}
                                        >
                                            <DeleteOutlined />
                                        </button>
                                    </td>
                                </tr>
                                {/* Unit breakdown row */}
                                {value?.unit_details_options?.length > 0 && (
                                    <tr>
                                        <td className="border border-gray-200 p-4"></td>
                                        <td className="border border-gray-200 p-4"></td>
                                        <td className="border border-gray-200 p-4"></td>
                                        <td className="border border-gray-200 p-4">
                                            {value?.unit_details_options?.map((v, i) => (
                                                <div className="pt-2" key={i}>
                                                    <div className="pb-2 text-gray-700 uppercase">
                                                        {v?.name} ({v?.conversion})
                                                    </div>
                                                    <div className="border border-gray-200 p-1 rounded-md">
                                                        {v?.unit_quantity}
                                                    </div>
                                                </div>
                                            ))}
                                        </td>
                                        <td className="border border-gray-200 p-4"></td>
                                    </tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <td className="border p-4" colSpan={5}>
                            <div className="text-center">
                                <AddButton
                                    className={"form-save-button w-full h-full text-center"}
                                    onClick={handleAdd}
                                />
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
});

export default MRTable;